
import { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import ColorField from './ColorField';

export interface ColorItem {
  name: string;
  value: string;
  label: string;
  description?: string;
}

interface ColorCategoryPanelProps {
  title: string;
  description?: string;
  colors: ColorItem[];
  mode: 'light' | 'dark';
  onColorChange: (mode: 'light' | 'dark', key: string, value: string) => Promise<void>;
}

const ColorCategoryPanel = ({
  title,
  description,
  colors,
  mode,
  onColorChange
}: ColorCategoryPanelProps) => {
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <Card>
      <CardHeader className="cursor-pointer" onClick={() => setIsExpanded(!isExpanded)}>
        <CardTitle className="text-base font-medium flex justify-between items-center">
          {title}
          <span className="text-sm">
            {isExpanded ? '▼' : '►'}
          </span>
        </CardTitle>
        {description && <CardDescription>{description}</CardDescription>}
      </CardHeader>
      
      {isExpanded && (
        <CardContent className="pt-0">
          <div className="grid gap-4">
            {colors.map((color) => (
              <ColorField 
                key={color.name}
                colorName={color.name}
                colorLabel={color.label}
                colorValue={color.value}
                description={color.description}
                onSave={(value) => onColorChange(mode, color.name, value)}
              />
            ))}
          </div>
        </CardContent>
      )}
    </Card>
  );
};

export default ColorCategoryPanel;
